import moment from "moment";

export const getFormattedDate = (d) => {
	let date = new Date(d);
	return `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
		.getDate()
		.toString()
		.padStart(2, "0")}/${date.getFullYear()}`;
};

export const convertLocaltoUTCFormat = (date) => {
	return moment.utc(date).format("DD-MMM-YYYY HH:mm:ss");
};

export const convertLocaltoUTCDate = (date) => {
	return moment.utc(date).format("DD-MMM-YYYY");
};

export const convertToUTC = (date) => {
	return moment.utc(new Date(date)).format("YYYY-MM-DD HH:mm:ss");
};

export const useAsUtc = (date) =>{
	return new Date(date + " UTC");
}

export const convertStringtoUTCFormat = (date) => {
	if (!(date instanceof Date) || isNaN(date)) {
		return "-";
	}
	return date.toISOString(); // Returns date in UTC ISO 8601 format
};